import script from "./VolatilityUniverseView.vue?vue&type=script&setup=true&lang=js"
export * from "./VolatilityUniverseView.vue?vue&type=script&setup=true&lang=js"

import "./VolatilityUniverseView.vue?vue&type=style&index=0&id=3bf8973b&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bf8973b"]])

export default __exports__